import React from 'react';

export function TTRGLogo({ className = "w-8 h-8" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      fill="currentColor"
    >
      {/* Robot Head */}
      <rect x="25" y="20" width="50" height="45" rx="5" fill="currentColor" />
      
      {/* Eyes */}
      <circle cx="40" cy="40" r="6" fill="#FFFFFF" />
      <circle cx="60" cy="40" r="6" fill="#FFFFFF" />
      <circle cx="40" cy="40" r="3" fill="#00A3FF" />
      <circle cx="60" cy="40" r="3" fill="#00A3FF" />
      
      {/* Antenna */}
      <rect x="47" y="10" width="6" height="10" fill="currentColor" />
      <circle cx="50" cy="8" r="4" fill="currentColor" />
      
      {/* Mouth Grid */}
      <rect x="35" y="50" width="30" height="5" fill="#FFFFFF" />
      <rect x="35" y="50" width="6" height="5" fill="currentColor" />
      <rect x="47" y="50" width="6" height="5" fill="currentColor" />
      <rect x="59" y="50" width="6" height="5" fill="currentColor" />
      
      {/* Neck */}
      <rect x="40" y="65" width="20" height="5" fill="currentColor" />
      
      {/* Body */}
      <path
        d="M30 70 
           h40
           a5 5 0 0 1 5 5
           v15
           a5 5 0 0 1 -5 5
           h-40
           a5 5 0 0 1 -5 -5
           v-15
           a5 5 0 0 1 5 -5
           z"
        fill="currentColor"
      />
      
      {/* Circuit Lines */}
      <path
        d="M35 75 h30 M35 80 h30 M35 85 h30"
        stroke="#FFFFFF"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  );
}